export default "__VITE_ASSET__A_q9IWE0__"